import PropTypes from "prop-types";
import IconArrow from '../public/images/arrow-right.svg'
import {useRouter} from "next/router";

const HomeHowTo = ({howto}) => {
  const {locale} = useRouter();

  return (
    <div className="howto-home" id="howto">
      <h2 className="howto-home__title">How-To PDF Guides</h2>
      <div className="howto-home__content content">
        {howto.map(({title, link, linkText, content}) => (
          <div key={title} className="howto-home_item-background">
            <div className="howto-home__item">
              <h3>
                {title}
              </h3>
              {content.map((paragraph, i) => (
                <p key={`${title}:${i}`} className="howto-home__link-block">
                  <span className="howto-home__id">{i + 1}</span>
                  <span dangerouslySetInnerHTML={{__html: paragraph}}></span>
                </p>
              ))}
              <a className="howto-home__link" href={`${locale}${link}`}>
                {linkText}
                <IconArrow className="howto-home__link-icon"/>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

HomeHowTo.propTypes = {
  howto: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    content: PropTypes.arrayOf(
      PropTypes.string.isRequired,
    ).isRequired,
  })).isRequired,
};

export default HomeHowTo;
